import React from "react";
import { Container, Row } from "reactstrap";
import JobContent from "./JobContent";
import Section from "./Section";

const CreateJob = () => {
  document.title = "Thông tin đơn tuyển";
  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container fluid>
          <Row>
            <JobContent />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default CreateJob;
